export enum OasisAssessmentTypeEnum {
  StartOfCare = 1,
  ROC = 3,
  RecertFollowUp = 2,
  OtherFollowUp = 4,
  Transfer = 5,
  TransferDischarge = 6,
  Discharge = 7,
  DeathAtHome = 8
}

export const OasisAssessmentTypeOptions = [
{ id: 1, label: 'Start Of Care (SOC)', abbreviation: 'SOC', assessmentCode: 1 },
{ id: 3, label: 'Resumption of Care (ROC)', abbreviation: 'ROC', assessmentCode: 3 },
{ id: 2, label: 'Recertification Follow-up (REC)', abbreviation: 'REC', assessmentCode: 4 },
{ id: 4, label: 'Other Follow-up (FU)', abbreviation: 'FU', assessmentCode: 5 },
{ id: 5, label: 'Transfer No Dischage (TRN)', abbreviation: 'TRN', assessmentCode: 6 },
{ id: 6, label: 'Transfer W/ Dischage (TRN)', abbreviation: 'DTRN', assessmentCode: 7 },
{ id: 7, label: 'Discharge (DC)', abbreviation: 'DC', assessmentCode: 8 },
{ id: 8, label: 'Death at home (DAH)', abbreviation: 'DAH', assessmentCode: 9 }
];
